export type ShortcutItem = {
  key: string;
  label: string;
  description: string;
};

export const shortcutItems: ShortcutItem[] = [
  {
    key: 'Alt / Option + C',
    label: 'Company search',
    description: 'Open company search modal',
  },
  {
    key: 'Alt / Option + D',
    label: 'Driver search',
    description: 'Open driver search modal',
  },
  {
    key: 'Alt / Option + U',
    label: 'Dashboard user search',
    description: 'Open dashboard user search modal',
  },
  {
    key: 'Alt / Option + A',
    label: 'Admin user search',
    description: 'Open admin user search modal',
  },
];
